import React from 'react';
import { motion } from 'framer-motion';
export function RealProblemSection() {
  return <section className="bg-[#141210]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-175">
      <div className="max-w-2xl mx-auto text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-[#0D0D0D] p-6 sm:p-8 md:p-12 rounded-2xl border border-white/5 relative overflow-hidden" data-id="element-177">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#A52422] to-transparent opacity-50" data-id="element-178" />

          <h2 className="fluid-3xl font-bold text-white mb-6 font-serif" data-id="element-179">
            Esto es lo que es <br data-id="element-180" />
            <span className="text-[#9A948C] font-sans font-normal fluid-lg" data-id="element-181">
              (y por qué duele tanto)
            </span>
          </h2>

          <p className="fluid-lg text-[#F5F0EB]/80 mb-6 leading-relaxed" data-id="element-182">
            Después de una ruptura, tu cerebro se comporta como si hubiera una
            emergencia.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-183">
            {['señales', 'explicaciones', 'contacto', 'una frase que lo arregle'].map((item, i) => <span key={i} className="px-3 py-1 bg-white/5 rounded text-[#F5F0EB]/70 fluid-sm" data-id="element-184">
                {item}
              </span>)}
          </div>

          <p className="fluid-lg text-[#F5F0EB]/90 mb-8" data-id="element-185">
            Pero el contacto en esta etapa funciona como{' '}
            <span className="text-white font-semibold" data-id="element-186">azúcar</span>:
          </p>

          <p className="fluid-xl font-serif italic text-[#A52422] mb-8" data-id="element-187">
            te calma 5 minutos… y te deja peor después.
          </p>

          <p className="text-[#9A948C] uppercase tracking-widest fluid-sm" data-id="element-188">
            Este PDF está diseñado para cortar ese circuito.
          </p>
        </motion.div>
      </div>
    </section>;
}